import { InstallationRefusal } from '@core/helpers/installation-refusal.helper';

export interface PlacedFindingRefusal {
  messageKey: string;
  // The finding is gone, so the page must read the report again.
  stale: boolean;
}

const KEY_PREFIX = 'installations.migrationReport.dialog.errors.';

const BAD_REQUESTS: Record<string, string> = {
  note_required: 'noteRequired',
  resolution_not_acknowledged: 'notAcknowledged',
};

// A 422 or an unknown reason means the request itself was wrong, which the user cannot fix, so it
// reads like any other failure to save.
export function placeFindingRefusal(refusal: InstallationRefusal): PlacedFindingRefusal {
  const { status, reason } = refusal;
  if (status === 400 && reason !== null && reason in BAD_REQUESTS) {
    return { messageKey: KEY_PREFIX + BAD_REQUESTS[reason], stale: false };
  }
  if (status === 401 || status === 403) {
    return { messageKey: KEY_PREFIX + 'notAllowed', stale: false };
  }
  if (status === 404) {
    return { messageKey: KEY_PREFIX + 'gone', stale: true };
  }
  return { messageKey: KEY_PREFIX + 'notSaved', stale: false };
}
